export const FOOTER_TEXTS = [
  {
    title: 'footer_services',
    links: [
      {
        title: 'footer_service_android',
        href: '/android-app-development-services/',
      },
      {
        title: 'footer_service_ios',
        href: '/ios-app-development-services/',
      },
      {
        title: 'footer_service_mobile',
        href: '/mobile-application-development-services/',
      },
      {
        title: 'footer_service_digital',
        href: '/digital-product-development-services/',
      },
      {
        title: 'footer_service_react',
        href: '/react-js-development-services/',
      },
      {
        title: 'footer_service_native',
        href: '/react-native-app-development-services/',
      },
      {
        title: 'footer_service_augmentation',
        href: '/it-staff-augmentation-services/',
      },
      {
        title: 'footer_service_web',
        href: '/web-application-development-services/',
      },
    ],
  },
  {
    title: 'footer_expertise',
    links: [
      {
        title: 'footer_expertise_ble',
        href: 'navigation_expertise_ble_href',
      },
      {
        title: 'footer_expertise_emsp',
        href: 'navigation_expertise_emsp_href',
      },
      {
        title: 'footer_expertise_iot',
        href: 'navigation_expertise_iot_href',
      },
      {
        title: 'footer_expertise_fitness',
        href: 'navigation_expertise_fitness_href',
      },
      {
        title: 'footer_expertise_ev',
        href: 'navigation_expertise_ev_href',
      },
      {
        title: 'footer_expertise_wearable',
        href: 'navigation_expertise_wearable_href',
      },
      {
        title: 'footer_expertise_iomt',
        href: 'navigation_expertise_iomt_href',
      },
      {
        title: 'footer_expertise_healthcare',
        href: 'navigation_expertise_healthcare_href',
      },
      {
        title: 'footer_expertise_meditation',
        href: 'navigation_expertise_meditation_href',
      },
    ],
  },
  {
    title: 'footer_company',
    links: [
      { title: 'footer_company_about', href: '/about-us/' },
      {
        title: 'footer_company_privacy_policy',
        href: '/privacy-policy/',
      },
      { title: 'footer_company_blog', href: '/blog/' },
      { title: 'footer_company_contact_us', href: '/contact-us/' },
    ],
  },
];
